import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    events: []
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    bindEvents: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "events",
        db
          .collection("events")
          .where("equipment", "==", db.collection("equipments").doc(id))
      );
    })
  },
  getters: {}
};
